import { FieldInputProps as FormikFieldInputProps, FieldMetaProps } from 'formik';
import React from 'react';

export interface FieldSelectProps<V = any> {
  field: FormikFieldInputProps<V> & { id?: string };
  meta: FieldMetaProps<V>;
  type?: string;
  children: any;
}

export function FieldSelect({ children, ...props }: FieldSelectProps) {
  return (
    <div className='relative flex flex-row'>
      <select
        className='block w-full px-4 py-3 pr-8 leading-tight text-gray-700 bg-gray-200 border rounded-lg shadow appearance-none border-gray-default focus:outline-none focus:bg-white focus:border-gray-500'
        {...props}
      >
        {children}
      </select>
      <span className='absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none'>
        <svg className='w-4 h-4 fill-current' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'>
          <path d='M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z' />
        </svg>
      </span>
    </div>
  );
}
